import Vue from 'vue'
/* 引入 better-scroll */
import BScroll from 'better-scroll'
import w from '@inrice/qm-wx-sdk'

/* 引入 mars-mta */
import mars from 'mars-mta'
import { toParams } from './utils/to-params'
import App from './App'
import store from './store'
import SDK from './sdk'
import env from '@/env'
import config from '@/config'
/* router & 历史栈 */
import { createRouter } from './router'
import { setRem } from './utils/rem'
import loadVConsole from './utils/vconsole'
import 'vant/lib/index.css'
const {
  appID = env.appID || 1,
  actID = env.actID || 1
} = toParams()
console.log('appID', appID)
console.log('actID', actID)
window.$inrice = {
  appID,
  actID
}
Vue.use(w, {
  configUrl: `${env.host}${env.wxJSSDKConfig || config.wechatConfig.wechatConfigUrl || ''}`,
  config: {
    url: encodeURIComponent(location.href.split('#')[0]),
    app_id: window.$inrice.appID
  }
})
Vue.use(mars, env.MTAConfig)
loadVConsole()
const router = createRouter()
/* setting font-size */
setRem(document, window)
Object.defineProperty(Vue.prototype, '$env', { value: env })
Object.defineProperty(Vue.prototype, '$config', { value: config })
/* 引入 SDK 并挂载在 Vue 上 */
for (var i in SDK) {
  Object.defineProperty(Vue.prototype, `$${i}`, { value: SDK[i] })
}
/* 返回前一个页面回到原本位置 */
Vue.mixin({
  data () {
    return {
      contentBScrollWrap: null // contentBScroll 容器
    }
  },
  methods: {
    async setWxShare () {
      console.log('当前id', this.$store.state.blessId)
      if (this.$store.state.blessId) {
        this.$setShare({
          title: `${this.$store.state.actInfo.nickname}给你发来一封甜蜜信，点击查收！`,
          desc: '送你的七夕礼物～请收好！',
          link: location.protocol + '//' + location.hostname + location.pathname + `?appID=4&actID=2#/loading?id=${this.$store.state.blessId}`,
          imgUrl: 'https://qhd-dev.oss-cn-shenzhen.aliyuncs.com/J217131414751837.png',
          success: function () {
          }
        })
      } else {
        this.$setShare({
          title: '招银告白信，有你“财”幸福！',
          desc: '大牌口红、星巴克、现金红包等甜蜜好礼等你来领~',
          link: location.protocol + '//' + location.hostname + location.pathname + '?appID=4&actID=2#/loading',
          imgUrl: 'https://qhd-dev.oss-cn-shenzhen.aliyuncs.com/J217131414751837.png',
          success: function () {
          }
        })
      }
    },
    async initBScroll () {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          // ref 必须是 contentBScrollWrap
          if (this.$refs.contentBScrollWrap) {
            // 路由切换后，返回页面滚动前位置。
            // 对于 keep-alive 的页面，滚动情况也会被保存，不需担心。
            // 这里路由切换的返回滚动主要针对没有 keep-alive 的长页面，在 init 时把存在 vuex 里的 scrollY 给到 startY。
            const fullPath = this.$route.fullPath
            const scrollY = this.$store.state.appShell.historyPageScrollY[fullPath] || 0
            const scrollbar = {
              fade: true,
              interactive: false // 1.8.0 新增
            }
            const options = {
              click: true,
              startY: scrollY,
              scrollbar,
              preventDefaultException: { className: /(^|\s)out-of-bs(\s|$)/ }
            }
            // 需要上拉加载更多的页面
            if (this.$route.meta.needPullUp) {
              options.pullUpLoad = {
                threshold: 50
              }
            }
            // 需要下拉刷新的页面
            if (this.$route.meta.needPullUp) {
              options.pullDownRefresh = {
                threshold: 50,
                stop: 20
              }
            }
            this.contentBScrollWrap = new BScroll(this.$refs.contentBScrollWrap, options)
            resolve()
          }
        })
      })
    }
  },
  // 路由切换前，保存页面滚动位置
  beforeRouteLeave (to, from, next) {
    if (this.contentBScrollWrap) {
      const scrollY = this.contentBScrollWrap.y
      this.$store.dispatch('appShell/saveScrollY', { path: from.fullPath, scrollY: scrollY })
    }
    next()
  },
  beforeRouteEnter (_to, _from, next) {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  render: h => h(App),
  async created () {
  }
})
